import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgItalic02 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.25 4-6 16m9.5-16-6 16M19.5 4h-10m5 16h-10"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgItalic02)
export default ForwardRef
